/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');
var Backbone = require('backbone');
var Ladda = require('ladda');
var _ = require('underscore');

var SideNavSectionView = require('common/views/SideNavSectionView');
var openInNewTab = require('common/util/openInNewTab');
var toggleForm = require('common/util/toggleForm');

var DepBankConversionPubReqsSectionView = require('./DepBankConversionPubReqsSectionView');
var DepFilingPointOfContactSectionView = require('../../views/DepFilingPointOfContactSectionView');
var DepFilingLawyerSectionView = require('../../views/DepFilingLawyerSectionView');
var DepFilingInstructionsSectionView = require('../../views/DepFilingInstructionsSectionView');
var DepFilingSupportingDocumentsSectionView = require('../../views/DepFilingSupportingDocumentsSectionView');
var DepFilingCertificationView = require('../../views/DepFilingCertificationView');

var DepBankConversionInfoSectionView = require('./DepBankConversionInfoSectionView');
var DepBankConversionRequiredInfoDocSectionView = require('./DepBankConversionRequiredInfoDocSectionView');

var SubmitBankConversionFiling = require('../../services/SubmitBankConversionFiling');

require('../../styles/DepFilingPrintView.css');
var tmplDepBankConversionFilingView = require('./DepBankConversionFilingView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepBankConversionFilingView,

  className: 'dep-bank-conversion-filing-view m-b-md',

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  ui: {
    filingSections: '.filing-sections'
  },

  regions: {
    filingSections: '@ui.filingSections'
  },

  onBeforeShow: function() {
    var filingId = this.model.get('filingId');

    var filingDetails = this.model.get('filingDetails') || {};
    var filingContent = this.model.get('filingContent') || {};
    var lawyers = this.model.get('lawyers') || filingDetails.lawyers;

    var instructionsDocument = filingDetails.instructionsDocument;
    var additionalInstructionDocuments = filingDetails.instructionsDocuments;
    var instructions = filingDetails.instructions;
    var pointOfContact = filingDetails.pointOfContact;
    var mode = this.options.mode;
    var isNewExternal = mode === 'ext-new';
    var isForPrinting = mode === 'print';
    var isExpandInternal = mode === 'int-expand';

    this.form = new SideNavSectionView({
      collection: new Backbone.Collection([
        {
          id: 'pointOfContact',
          title: 'Point of Contact',
          view: new DepFilingPointOfContactSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            hasAddress: true,
            model: new Backbone.Model(pointOfContact)
          })
        },
        {
          id: 'bankConversionSubmissionLawyer',
          title: 'Filer',
          view: new DepFilingLawyerSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              lawyers: lawyers,
              currentLawyer: filingDetails.lawyer
            })
          })
        },
        {
          id: 'conversionInfos',
          title: 'Conversion Information',
          view: new DepBankConversionInfoSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: this.model
          })
        },
        {
          id: 'instructions',
          title: 'Section I - General Information and Instructions',
          view: new DepFilingInstructionsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              instructionsDocument: instructionsDocument,
              additionalInstructionDocuments: additionalInstructionDocuments,
              instructions: instructions
            })
          })
        },
        {
          id: 'publicationReqsDoc',
          title: 'Section II - Publication Requirements',
          view: new DepBankConversionPubReqsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({ filingContent: filingContent })
          })
        },
        {
          id: 'requiredInfosDoc',
          title: 'Section III - Required Information and Documentation',
          view: new DepBankConversionRequiredInfoDocSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({ filingContent: filingContent })
          })
        },
        {
          id: 'supportingDocuments',
          title: 'Other Supporting Documents',
          view: new DepFilingSupportingDocumentsSectionView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            model: new Backbone.Model({
              filingDetails: filingDetails,
              filingContent: filingContent
            })
          })
        },
        {
          id: 'certification',
          title: 'Certification',
          view: new DepFilingCertificationView({
            mode: this.options.mode,
            isReadOnly: this.options.isReadOnly,
            submitService: SubmitBankConversionFiling,
            model: new Backbone.Model({
              filingId: filingId,
              id: filingContent.conversionId,
              filingDetails: filingDetails
            })
          })
        }
      ]),
      useNavigationButtons: !this.options.isReadOnly,
      expanded: isForPrinting || isExpandInternal,
      contentWidth: 'medium',
      buttons: [
        {
          buttonText: 'Save',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-save',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickSave.bind(this)
        },
        {
          buttonText: 'Save & Print',
          buttonClass: 'btn-default ladda-button',
          buttonIconClass: 'fa-print',
          labelClass: 'ladda-label',
          buttonAttrs: {
            'data-style': 'expand-right'
          },
          onClick: this.onClickPrint.bind(this)
        }
      ]
    });

    if (this.options.isReadOnly) {
      this.form.collection.remove(this.form.collection.get('instructions'));
      this.form.collection.remove(this.form.collection.get('certification'));
    }

    // If this isn't the new external form, or if the form is in print mode, remove the buttons
    if (!isNewExternal || isForPrinting) {
      this.form.options.buttons = [];
    }

    this.showChildView('filingSections', this.form);
  },

  onAttach: function() {
    if (this.options.mode === 'print') {
      this.switchToPrint();
    }
  },

  switchToPrint: function() {
    var textAreas = $('.input-view');

    _.each(textAreas, function(textArea) {
      var textAreaVal = textArea.value;
      var textAreaName = textArea.name;
      var printElementId = '#'.concat(textAreaName, 'PrintView');
      $(printElementId).text(textAreaVal);
    });
    toggleForm(textAreas, false);
  },

  onClickSave: function(e) {
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
  },

  onClickPrint: function(e) {
    var filingId = this.model.get('filingId');
    var l = Ladda.create(e.currentTarget);
    l.start();

    this.saveForm()
      .done(function() {
        openInNewTab('#ext/dep/filing/' + filingId + '/print');
        l.stop();
      })
      .fail(function() {
        l.stop();
      });
  },

  saveForm: function() {
    var deferred = $.Deferred();
    var self = this;
    var filingId = this.model.get('filingId');
    var filingContent = this.model.get('filingContent') || {};

    this.form
      .validateAll({ type: 'save' })
      .done(function() {
        var formData = self.form.getFormData();
        formData.filingId = filingId;
        formData.id = filingContent.conversionId;
        SubmitBankConversionFiling(formData)
          .done(function() {
            deferred.resolve();
          })
          .fail(function() {
            deferred.reject();
          });
      })
      .fail(function() {
        deferred.reject();
      });
    return deferred.promise();
  }
});
